import React from 'react';
import { useSubscription } from '../contexts/SubscriptionContext';
import { Link } from 'react-router-dom';
import { 
  AlertTriangle, 
  //CreditCard, 
  //Calendar, 
  Lock,
  //RefreshCw
} from 'lucide-react';
import { format } from 'date-fns';

const SubscriptionGuard = ({ children }) => {
  const { 
    subscriptionStatus, 
    isSubscriptionValid, 
    daysExpired
  } = useSubscription();

  // If subscription is valid, render children
  if (isSubscriptionValid) {
    return children;
  }

  // If still loading, show loading state
  if (!subscriptionStatus) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Checking subscription status...</p>
        </div>
      </div>
    );
  }

  // Show subscription expired screen
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
            <Lock className="h-8 w-8 text-red-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Subscription Required</h1>
          <p className="text-gray-600">
            Your subscription has expired. Please renew to continue using the app.
          </p>
        </div>

        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
          <div className="flex items-center justify-center mb-2">
            <AlertTriangle className="h-5 w-5 text-red-600 mr-2" />
            <span className="text-sm font-medium text-red-900">Subscription Expired</span>
          </div>
          <p className="text-sm text-red-700">
            {daysExpired > 0 
              ? `Expired ${daysExpired} days ago` 
              : 'Subscription has expired'
            }
          </p>
          {subscriptionStatus.lastPaymentDate && (
            <p className="text-xs text-red-600 mt-1">
              Last payment: {format(new Date(subscriptionStatus.lastPaymentDate), 'MMM dd, yyyy')}
            </p>
          )}
        </div>

        <div className="space-y-3">
          <Link to="/payment" className="w-full btn btn-primary btn-lg">
            Subscribe Now
          </Link>
          <Link to="/subscription" className="w-full btn btn-outline btn-lg">
            View Subscription Status
          </Link>
        </div>

        <div className="mt-6 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-500">
            Need help? Contact support for assistance with your subscription.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionGuard;
